<template>
    <div class="container">
        <div class="checkout-steps">
            <div class="checkout-steps__item" :class="getClass(1)" @click="$emit('step', 1)">
                <span>1</span>
                <p :class="step === 1 ? 'active-checkout-step' : ''" class="headline-sm breadcrumbs-checkout">{{breadcrumbsCart}}</p>
            </div>
            <div class="checkout-steps__item" :class="getClass(2)" @click="$emit('step', 2)">
                <span>2</span>
                <p :class="step === 2 ? 'active-checkout-step' : ''" class="headline-sm breadcrumbs-checkout">{{breadcrumbsPersonal}}</p>
            </div>
            <div class="checkout-steps__item">
                <span>3</span>
                <p class="headline-sm breadcrumbs-checkout">{{breadcrumbsPayment}}</p>
            </div>
        </div>
    </div>
    <div class="horizontal-line"></div>
</template>

<script>
    export default {
        name: "CheckoutSteps",
        props: {
            step: {
                type: Number,
                default: 1
            }
        },
        computed: {
            breadcrumbsCart(){
                if (window.innerWidth <= 768) {
                    switch (this.step){
                        case 1: return 'סל קניות'
                        default: return 'סל קניות'
                    }
                } else {
                    return 'סל קניות'
                }
            },
            breadcrumbsPersonal(){
                if (window.innerWidth <= 768) {
                    switch (this.step){
                        case 2: return 'פרטי לקוח'
                        default: return 'פרטי לקוח'
                    }
                } else {
                    return 'פרטי לקוח'
                }
            },
            breadcrumbsPayment(){
                if (window.innerWidth <= 768) {
                    switch (this.step){
                        case 3: return 'תשלום'
                        default: return 'תשלום'
                    }
                } else {
                    return 'תשלום'
                }
            },
        },
        data() {
            return {
            }
        },
        methods: {
            getClass(step) {
                return {
                    active: step <= this.step
                }
            }
        }
    }
</script>

<style scoped>
  .breadcrumbs-checkout {

  }
</style>
